<script>
import { isTranscriptMessage } from 'dashboard/helper/jarabotHelper';

export default {
  name: 'MessageGroup',
  props: {
    group: {
      type: Array,
      required: true,
    },
    lastMessage: {
      type: Object,
      default: null,
    },
    alwaysVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    isVisible() {
      if (this.visible || !this.lastMessage || this.alwaysVisible) {
        return true;
      }

      const message = this.group[this.group.length - 1];

      if (this.lastMessage.id === message.id) {
        return true;
      }

      if (this.group.some(m => isTranscriptMessage(m))) {
        return true;
      }

      return !(
        (message.private && message.contentAttributes?.jarabot) ||
        message.isAutomated
      );
    },
  },
  methods: {
    show: function () {
      this.visible = true;
    },
  },
};
</script>

<template>
  <div class="message-group">
    <slot v-if="isVisible" />
    <div
      v-else
      class="flex w-full message-bubble-container mb-2 justify-center"
    >
      <div
        class="text-sm bg-n-alpha-1 text-n-slate-11 rounded-lg max-w-lg px-2 py-0.5 !rounded-full flex min-w-0 items-center gap-2"
        data-bubble-name="message-group"
      >
        <span
          v-dompurify-html="$t(`CONVERSATION.SHOW_HIDDEN_MESSAGES`)"
          :title="$t(`CONVERSATION.SHOW_HIDDEN_MESSAGES`)"
          class="cursor-pointer text-blue-500 hover:underline"
          @click="show"
        />
      </div>
    </div>
  </div>
</template>
